(() => {
  const root = document.querySelector('.ov-hadley');
  if (!root) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = navigator.connection?.saveData;
  const rail = root.querySelector('.hd-film-rail');
  const videos = [...root.querySelectorAll('.hd-preview-video')];
  const pauseButton = root.querySelector('.hd-pause-previews');
  const embeds = [...root.querySelectorAll('.hd-tiktok-preview')];
  const embedReady = new WeakSet();
  const embedFailed = new WeakSet();
  const messagePlayer = (frame, type) => frame.contentWindow?.postMessage({'x-tiktok-player':true, type}, 'https://www.tiktok.com');
  // TikTok's muted=1 locks volume. The first sound click promotes that same
  // frame to an unlocked player; later clicks use its mute/unMute messages.
  const embedUrl = (id, preview) => `https://www.tiktok.com/player/v1/${id}?autoplay=1&muted=${preview ? 1 : 0}&controls=1&loop=1&rel=0&music_info=0&description=0&closed_caption=1`;
  const phone = matchMedia('(max-width: 749px)');
  let paused = phone.matches || motion.matches || !!saveData;
  let activeCard = null;
  const cards = [...root.querySelectorAll('.hd-film-card')].map(element => ({
    element, button: element.querySelector('.hd-film-sound'),
    playButton: element.querySelector('.hd-film-play'), frameButton: element.querySelector('.hd-film-start'),
    media: element.querySelector('.hd-preview-video, .hd-tiktok-preview'),
    started: false, sound: false, requestedSound: false
  }));
  const updatePlayback = card => {
    const playing = card.started && card.sound && (card.media.tagName === 'VIDEO' ? !card.media.paused : card.media.dataset.playerState === '1');
    const label = playing ? card.playButton.dataset.pause : card.playButton.dataset.play;
    card.playButton.classList.toggle('is-playing', playing);
    card.playButton.querySelector('span').textContent = label;
    card.playButton.setAttribute('aria-label', `${label}: ${card.button.dataset.title}`);
    // Give the real player its controls once the visitor has started sound.
    card.frameButton.hidden = playing;
  };
  const updateSound = (card, sound) => {
    card.sound = sound;
    card.button.classList.toggle('is-audible', sound);
    const label = sound ? card.button.dataset.mute : card.button.dataset.unmute;
    card.button.querySelector('span').textContent = label;
    card.button.setAttribute('aria-label', `${label}: ${card.button.dataset.title}`);
    updatePlayback(card);
  };
  const silence = (card, stop = false) => {
    if (!card) return;
    card.requestedSound = false;
    if (card.media.tagName === 'VIDEO') {
      card.media.muted = true;
      if (stop) card.media.pause();
    } else {
      messagePlayer(card.media, 'mute');
      if (stop) messagePlayer(card.media, 'pause');
    }
    updateSound(card, false);
    if (stop && activeCard === card) activeCard = null;
  };
  const isVisible = video => {
    const r = video.getBoundingClientRect();
    const rr = rail.getBoundingClientRect();
    return r.bottom > 0 && r.top < innerHeight && r.right > rr.left + 60 && r.left < Math.min(rr.right, innerWidth) - 60;
  };
  const refresh = () => {
    cards.forEach(card => {
      const media = card.media;
      if (card === activeCard) {
        if (document.hidden || !isVisible(media)) silence(card, true);
        return; // Native controls own playback after the explicit click.
      }
      const play = !card.started && !paused && !motion.matches && !document.hidden && isVisible(media);
      if (media.tagName === 'VIDEO') {
        if (play) {
          if (!media.hasAttribute('src')) { media.src = media.dataset.src; media.load(); }
          media.play().catch(() => {});
        } else media.pause();
      } else {
        if (play && !media.hasAttribute('src')) media.src = embedUrl(media.dataset.tiktokId, true);
        if (embedReady.has(media) && !embedFailed.has(media)) messagePlayer(media, play ? 'play' : 'pause');
      }
    });
    pauseButton.textContent = paused ? pauseButton.dataset.playText : pauseButton.dataset.pauseText;
    pauseButton.setAttribute('aria-pressed', String(paused));
  };
  const observer = new IntersectionObserver(refresh, {threshold:[0,.25,.6]});
  videos.forEach(video => observer.observe(video));
  embeds.forEach(frame => observer.observe(frame));
  window.addEventListener('message', event => {
    if (event.origin !== 'https://www.tiktok.com' || !event.data?.['x-tiktok-player']) return;
    const frame = embeds.find(item => item.contentWindow === event.source);
    if (!frame) return;
    const card = cards.find(item => item.media === frame);
    if (event.data.type === 'onPlayerReady') {
      embedReady.add(frame);
      if (activeCard === card) {
        messagePlayer(frame, card.requestedSound ? 'unMute' : 'mute');
        messagePlayer(frame, 'play');
      } else { messagePlayer(frame, 'mute'); refresh(); }
    }
    if (event.data.type === 'onStateChange') {
      frame.dataset.playerState = String(event.data.value);
      if (event.data.value === 1) frame.classList.add('is-playing');
      updatePlayback(card);
    }
    if (event.data.type === 'onMute') {
      frame.dataset.muted = String(event.data.value);
      if (!event.data.value) card.requestedSound = false;
      if (!event.data.value && activeCard !== card) silence(card, card.started);
      else updateSound(card, !event.data.value);
    }
    if (event.data.type === 'onCurrentTime') frame.dataset.currentTime = String(event.data.value.currentTime);
    if (event.data.type === 'onPlayerError' || event.data.type === 'onError') {
      frame.dataset.playerError = String(event.data.value?.errorCode || event.data.value);
      embedFailed.add(frame); silence(card, true);
    }
  });
  pauseButton.addEventListener('click', () => { paused = !paused; if (paused) silence(activeCard, true); refresh(); });
  motion.addEventListener('change', () => { if (motion.matches) { paused = true; silence(activeCard, true); } refresh(); });
  phone.addEventListener('change', () => { if (phone.matches) paused = true; refresh(); });
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('ov:motion', event => { paused = event.detail; if (paused) silence(activeCard, true); refresh(); });
  videos.forEach(video => ['play','pause'].forEach(event => video.addEventListener(event, () => document.dispatchEvent(new CustomEvent('ov:preview-state')))));
  rail.addEventListener('scroll', refresh, {passive:true});
  const arrows = [...root.querySelectorAll('[data-hd-direction]')];
  const updateArrows = () => arrows.forEach(button => {
    button.disabled = Number(button.dataset.hdDirection) < 0 ? rail.scrollLeft < 4 : rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4;
  });
  arrows.forEach(button => button.addEventListener('click', () => {
    rail.scrollBy({left:Number(button.dataset.hdDirection) * (rail.querySelector('.hd-film-card').getBoundingClientRect().width + 20), behavior:motion.matches ? 'instant' : 'smooth'});
  }));
  rail.addEventListener('scroll', updateArrows, {passive:true});
  new ResizeObserver(updateArrows).observe(rail);
  cards.forEach(card => {
    const media = card.media;
    if (media.tagName === 'VIDEO') {
      media.addEventListener('volumechange', () => {
        if (!media.muted && activeCard !== card) { silence(activeCard, true); activeCard = card; }
        updateSound(card, !media.muted && media.volume > 0);
      });
      media.addEventListener('ended', () => silence(card, true));
      ['play', 'pause'].forEach(type => media.addEventListener(type, () => updatePlayback(card)));
    }
    const playWithSound = () => {
      silence(activeCard, true);
      activeCard = card;
      card.started = true;
      card.requestedSound = true;
      card.element.querySelector('.hd-film-cover').classList.add('is-interactive');
      if (media.tagName === 'VIDEO') {
        if (media.getAttribute('src') !== card.button.dataset.full) { media.src = card.button.dataset.full; media.load(); }
        media.controls = true;
        media.loop = false;
        media.muted = false;
        media.volume = 1;
        media.play().then(() => { card.requestedSound = false; updateSound(card, !media.muted); }).catch(() => silence(card, true));
      } else {
        media.removeAttribute('aria-hidden');
        media.removeAttribute('tabindex');
        if (!media.hasAttribute('src') || new URL(media.src).searchParams.get('muted') === '1' || embedFailed.has(media)) {
          embedReady.delete(media); embedFailed.delete(media);
          media.src = embedUrl(media.dataset.tiktokId, false);
        } else {
          messagePlayer(media, 'unMute');
          messagePlayer(media, 'play');
        }
      }
    };
    card.button.addEventListener('click', () => {
      if (activeCard === card && (card.sound || card.requestedSound)) silence(card);
      else playWithSound();
    });
    card.frameButton.addEventListener('click', playWithSound);
    card.playButton.addEventListener('click', () => {
      if (card.playButton.classList.contains('is-playing')) silence(card, true);
      else playWithSound();
    });
    updatePlayback(card);
  });
  const ribbon = root.querySelector('.hd-ribbon');
  const ribbonButton = root.querySelector('.hd-motion');
  // Keep Amanda at the start until the ribbon enters view; stop offscreen work.
  ribbon.classList.add('is-offscreen');
  let ribbonVisible = false;
  const syncRibbonVisibility = () => ribbon.classList.toggle('is-offscreen', !ribbonVisible || document.hidden);
  new IntersectionObserver(entries => {
    ribbonVisible = entries[0].isIntersecting;
    syncRibbonVisibility();
  }).observe(ribbon);
  document.addEventListener('visibilitychange', syncRibbonVisibility);
  if (motion.matches || saveData) ribbon.classList.add('is-paused');
  const updateRibbon = () => { const stopped = ribbon.classList.contains('is-paused'); ribbonButton.textContent = stopped ? '▶' : 'Ⅱ'; ribbonButton.setAttribute('aria-label', stopped ? ribbonButton.dataset.playText : ribbonButton.dataset.pauseText); ribbonButton.setAttribute('aria-pressed', String(stopped)); };
  ribbonButton.addEventListener('click', () => {ribbon.classList.toggle('is-paused'); updateRibbon();});
  motion.addEventListener('change', () => { if(motion.matches) ribbon.classList.add('is-paused'); updateRibbon(); });
  updateRibbon(); refresh(); updateArrows();
  // Progressive enhancement: without JS all reviews remain readable.
  const reviews = root.querySelector('.ov-testimonials');
  const reviewToggle = reviews?.querySelector('.ov-reviews-toggle');
  if (reviewToggle) {
    reviews.classList.add('ov-reviews-collapsible');
    reviewToggle.hidden = false;
    reviewToggle.addEventListener('click', () => {
      const expanded = reviews.classList.toggle('is-expanded');
      reviewToggle.setAttribute('aria-expanded', String(expanded));
      reviewToggle.textContent = expanded ? reviewToggle.dataset.less : reviewToggle.dataset.more;
      if (!expanded) reviewToggle.scrollIntoView({block:'center', behavior:'instant'});
    });
  }
  root.querySelectorAll('img[data-fallback-src]').forEach(img => {
    const fallback = () => {
      if (!img.dataset.fallbackSrc) return;
      const url = img.dataset.fallbackSrc;
      delete img.dataset.fallbackSrc;
      img.src = url;
      img.alt = img.dataset.fallbackAlt || img.alt;
    };
    img.addEventListener('error', fallback, {once:true});
    if (img.complete && !img.naturalWidth) fallback();
  });
  if (!motion.matches) {
    const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {entry.target.classList.add('hd-enter'); reveal.unobserve(entry.target);}
    }), {threshold:.12});
    root.querySelectorAll('[data-hd-reveal]').forEach(el => reveal.observe(el));
  }
})();
